import React, { forwardRef, PropsWithChildren } from 'react';
import styled from 'styled-components';
import {
  JigsawComponent,
  solvSystem,
  SolvSystemProps,
  sx,
  WithSx,
} from '../../theme/system';

const StyledBox = styled.div<SolvSystemProps & WithSx>(solvSystem, sx);

/**
 * Box is the lowest-level component provided by Jigsaw. It is a wrapper around a
 * display-block div with all of the Jigsaw system props.
 *
 * The base `Box` component is the workhorse of the design system. It has props
 * for nearly all css and design-system related fields necessary, and can replace
 * most instances of `div`. It's support for the `as` prop allows for better
 * semantic HTML (though it does not update the props of the `Box` to reflect the
 * new Element -- though this is possible it **really** slows down Typescript still.)
 *
 * Only a small selection of props are included in the storybook. See the `System Props` page
 * for more details.
 */
export const Box = forwardRef(
  (props: PropsWithChildren<JigsawComponent>, ref) => {
    return <StyledBox {...props} ref={ref} />;
  },
);

export type BoxProps = React.ComponentProps<typeof Box>;

Box.displayName = 'Box';
export default Box;
